export const GET_ACTIVE_CARRIERS_SUCCESS = 'GET_ACTIVE_CARRIERS_SUCCESS';
export const GET_ACTIVE_CARRIERS_REQUEST = 'GET_ACTIVE_CARRIERS_REQUEST';
export const GET_ACTIVE_CARRIERS_FAILURE = 'GET_ACTIVE_CARRIERS_FAILURE';
export const GET_ACTIVE_CARRIERS_REST = 'GET_ACTIVE_CARRIERS_REST';
export const getActiveCarriersSuccess = (payload) => ({
    type: GET_ACTIVE_CARRIERS_SUCCESS,
    payload,
});
export const getActiveCarriersRequest = (payload) => ({
    type: GET_ACTIVE_CARRIERS_REQUEST,
    payload,
});
export const getActiveCarriersFailure = (payload) => ({
    type: GET_ACTIVE_CARRIERS_FAILURE,
    payload,
});
export const getActiveCarriersRest = () => ({
    type: GET_ACTIVE_CARRIERS_REST,
});
